// extracted by mini-css-extract-plugin
export default {"root":"OutsideClickHandler_root__UzuFm"};